import React from 'react';
export function Terms() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-11729" data-mp="11fc59nzh73uw">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-11730" data-mp="3tohf1d9vq8qm">
        Terms of Service
      </h1>

      <div className="space-y-10 text-neutral-700 font-body leading-relaxed text-[17px]" data-id="element-11731" data-mp="2hodu9f369m3">
        <section data-id="element-11732" data-mp="79pr9ynzq6dp">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11733" data-mp="7a7q9321eypb">
            1. Acceptance of Terms
          </h2>
          <p data-id="element-11734" data-mp="ga4a8rdhf9e1">
            By accessing or using Giga ("Service"), you agree to be bound by
            these Terms of Service. If you disagree with any part of the terms,
            you may not access the Service. These terms apply to all visitors,
            users, and others who access or use the Service.
          </p>
        </section>

        <section data-id="element-11735" data-mp="2n1vod1ssex9p">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11736" data-mp="2n2euzmczlz8f">
            2. Account Terms
          </h2>
          <ul className="list-disc pl-5 space-y-2" data-id="element-11737" data-mp="23931w4mj3uk3">
            <li data-id="element-11738" data-mp="23axm1gpz7in4">You must be 18 years or older to use this Service.</li>
            <li data-id="element-11739" data-mp="1yie82indmlhs">
              You must provide your legal full name, a valid email address, and
              any other information requested in order to complete the signup
              process.
            </li>
            <li data-id="element-11740" data-mp="1pj9bvizaf48s">
              You are responsible for maintaining the security of your account
              and password. Giga cannot and will not be liable for any loss or
              damage from your failure to comply with this security obligation.
            </li>
            <li data-id="element-11741" data-mp="2d70ypgigezob">
              You are responsible for all content posted and activity that
              occurs under your account.
            </li>
          </ul>
        </section>

        <section data-id="element-11742" data-mp="11sdm0ree6j46">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11743" data-mp="11swyvtp6qhbc">
            3. API Usage
          </h2>
          <p className="mb-4" data-id="element-11744" data-mp="wrpqbsf7xe3m">
            Customers may access their Giga account data via an API (Application
            Program Interface). Any use of the API, including use of the API
            through a third-party product that accesses Giga, is bound by these
            Terms of Service plus the following specific terms:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-11745" data-mp="tb3caa2ldigi">
            <li data-id="element-11746" data-mp="t9sagfspiks1">
              You expressly understand and agree that Giga shall not be liable
              for any direct, indirect, incidental, special, consequential or
              exemplary damages, including but not limited to, damages for loss
              of profits, goodwill, use, data or other intangible losses
              resulting from your use of the API.
            </li>
            <li data-id="element-11747" data-mp="aleu7hju9wik">
              Abuse or excessively frequent requests to Giga via the API may
              result in the temporary or permanent suspension of your account's
              access to the API.
            </li>
          </ul>
        </section>

        <section data-id="element-11748" data-mp="3e39nq0cl416h">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11749" data-mp="3e4uinr2t9m4v">
            4. Data and Privacy
          </h2>
          <p data-id="element-11750" data-mp="396t1xcsuxywk">
            Your use of the Service is also governed by our Privacy Policy. Giga
            claims no intellectual property rights over the material you provide
            to the Service. Your profile and materials uploaded remain yours.
          </p>
        </section>

        <section data-id="element-11751" data-mp="vez8bs4bl57">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11752" data-mp="uwu0pnh9wl5">
            4.5 User Data Deletion
          </h2>
          <p data-id="element-11753" data-mp="ancepuq5sz9q">
            You may delete your account at any time. Upon deletion, we will
            remove or anonymise your data within 30 days. You may also request
            deletion of specific integration data by contacting us at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11754" data-mp="jlocqhtcuzc7">
              support@getgiga.com
            </a>
            . We comply with data deletion requests as required by applicable
            law and the Google API Services User Data Policy.
          </p>
        </section>

        <section data-id="element-11755" data-mp="2iuxyn4t08jpk">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11756" data-mp="2iuftfiod6v5i">
            5. Termination
          </h2>
          <p data-id="element-11757" data-mp="2mvhve79o1lb6">
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms. All provisions
            of the Terms which by their nature should survive termination shall
            survive termination, including, without limitation, ownership
            provisions, warranty disclaimers, indemnity and limitations of
            liability.
          </p>
        </section>

        <section data-id="element-11758" data-mp="3ao884ipe88mi">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11759" data-mp="3fkow9cwlemzl">
            5.5 Acceptable Use
          </h2>
          <p data-id="element-11760" data-mp="3podnxgit18n5">
            You agree not to use the Service for any unlawful purpose or in
            violation of any applicable laws or regulations. You may not use
            the Service to transmit malware, spam, or content that infringes
            third-party rights. We reserve the right to suspend or terminate
            accounts engaged in prohibited use.
          </p>
        </section>

        <section data-id="element-11761" data-mp="36zyvqpwr3okr">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11762" data-mp="36wb3rv6yfa85">
            6. Limitation of Liability
          </h2>
          <p data-id="element-11763" data-mp="2wzg6tgqbxhvz">
            In no event shall Giga, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the Service.
          </p>
        </section>

        <section data-id="element-11764" data-mp="2pgfapghuyqin">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11765" data-mp="2pgyqorny74u1">
            7. Governing Law
          </h2>
          <p data-id="element-11766" data-mp="2br52mbk9oold">
            These Terms shall be governed by and construed in accordance with
            the laws of Ireland. Any disputes arising under these Terms shall
            be subject to the exclusive jurisdiction of the courts of Ireland.
          </p>
        </section>

        <section data-id="element-11767" data-mp="38e9n84i73k5s">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11768" data-mp="38ersfqmu58pu">
            8. Service Availability
          </h2>
          <p data-id="element-11769" data-mp="2zed5yny4xnkr">
            We strive for high availability but do not guarantee uninterrupted
            access. We reserve the right to perform maintenance, updates, or
            suspend access as needed with reasonable notice where practicable.
          </p>
        </section>

        <section data-id="element-11770" data-mp="1fipcndym6tmv">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11771" data-mp="1fi5zsbntmvfp">
            9. Third-Party Services
          </h2>
          <p data-id="element-11772" data-mp="1bguc4boicka5">
            Giga connects to third-party services you authorise via OAuth. We
            are not responsible for the availability, security, or data
            practices of those services. Your use of connected third-party
            services remains subject to their terms and privacy policies.
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-11773" data-mp="rtmtu2s8uuqs">
          <p className="text-sm text-neutral-500" data-id="element-11774" data-mp="rra2x04ida1l">Last updated: July 2026</p>
        </section>
      </div>
    </div>;
}